import { CustomErrorCode } from "@repo/shared";

import { DEFAULT_CURRENT_USER, DEFAULT_USER_DETAILS } from "~/constants/user";
import { signOut } from "~/lib/better-auth-client";
import { CURRENT_USER_STORAGE_KEY } from "~/types/shared";

import { API } from "./generated-api";

export const ApiClient = new API({
  baseURL:
    import.meta.env.VITE_SOCIAL === "true" ? "http://localhost:3000" : import.meta.env.VITE_APP_URL,
  secure: true,
  withCredentials: true,
});

const DEFAULT_CURRENT_USER_STORAGE = JSON.stringify({
  state: {
    currentUser: DEFAULT_CURRENT_USER,
    currentUserDetails: DEFAULT_USER_DETAILS,
  },
});

ApiClient.instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      if (window.location.pathname === "/auth/error") {
        return Promise.reject(error);
      }

      localStorage.setItem(CURRENT_USER_STORAGE_KEY, DEFAULT_CURRENT_USER_STORAGE);

      try {
        await signOut();
      } catch (signOutError) {
        console.error("❌ API Interceptor: Error during sign out:", signOutError);
      }

      window.location.href = "/auth";
      return Promise.reject(error);
    }

    if (
      error.response?.status === 403 &&
      error.response?.data?.errorCode === CustomErrorCode.USER_BANNED
    ) {
      if (window.location.pathname === "/auth/error") {
        return Promise.reject(error);
      }

      localStorage.setItem(CURRENT_USER_STORAGE_KEY, DEFAULT_CURRENT_USER_STORAGE);

      try {
        await signOut();
      } catch (signOutError) {
        console.error("Error during sign out:", signOutError);
      }

      window.location.href = "/auth";
    }

    return Promise.reject(error);
  },
);
